import React, { useState } from 'react';
import { API, apiFetch } from '../api';

const s = {
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(160deg, #DB3267 0%, #a02050 100%)',
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    padding: '24px',
  },
  card: {
    background: '#fff', borderRadius: '16px', padding: '32px 28px',
    width: '100%', maxWidth: '380px', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
  },
  title: { fontSize: '20px', fontWeight: '700', color: '#222', marginBottom: '4px', textAlign: 'center' },
  subtitle: { fontSize: '13px', color: '#888', marginBottom: '24px', textAlign: 'center', lineHeight: '1.5' },
  label: { display: 'block', fontSize: '12px', fontWeight: '600', color: '#555', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  input: {
    width: '100%', padding: '12px 14px', border: '1.5px solid #e0e0e0',
    borderRadius: '8px', fontSize: '15px', marginBottom: '16px', outline: 'none', boxSizing: 'border-box',
  },
  shiftRow: { display: 'flex', gap: '10px', marginBottom: '20px' },
  shiftBtn: { flex: 1, padding: '12px', borderRadius: '8px', border: '1.5px solid #e0e0e0', background: '#fff', fontSize: '14px', fontWeight: '600', color: '#555', cursor: 'pointer' },
  shiftBtnActive: { background: '#fce8ef', borderColor: '#DB3267', color: '#DB3267' },
  btn: { width: '100%', padding: '14px', background: '#DB3267', color: '#fff', borderRadius: '8px', fontWeight: '700', fontSize: '16px', cursor: 'pointer', border: 'none' },
  btnDisabled: { background: '#e0e0e0', color: '#aaa', cursor: 'not-allowed' },
  error: { background: '#fce8ef', color: '#b8254f', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', marginBottom: '16px', textAlign: 'center' },
  success: { background: '#e8f5e9', border: '1.5px solid #a5d6a7', borderRadius: '12px', padding: '28px 20px', textAlign: 'center' },
  successIcon: { fontSize: '48px', marginBottom: '12px' },
  successTitle: { fontSize: '18px', fontWeight: '700', color: '#2e7d32', marginBottom: '8px' },
  successText: { fontSize: '14px', color: '#555', lineHeight: '1.6' },
};

export default function Register() {
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [shift, setShift] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const canSubmit = name.trim() && username.trim() && password.trim() && shift;

  async function handleSubmit(e) {
    e.preventDefault();
    if (!canSubmit || submitting) return;
    setError('');
    setSubmitting(true);
    try {
      const res = await apiFetch(`${API}/users`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), username: username.trim().toLowerCase(), password, shift }),
      });
      const data = await res.json();
      if (data.ok) {
        setDone(true);
      } else {
        setError(data.error || 'Something went wrong. Please try again.');
      }
    } catch {
      setError('Could not connect. Please check your internet connection.');
    }
    setSubmitting(false);
  }

  if (done) {
    return (
      <div style={s.page}>
        <div style={s.card}>
          <div style={s.success}>
            <div style={s.successIcon}>✅</div>
            <div style={s.successTitle}>Request sent!</div>
            <div style={s.successText}>
              Your registration has been sent to the admin team.<br /><br />
              You'll be able to log in once they approve your account.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img src="/sah-logo.svg" alt="Support at Home" style={{ height: '36px' }} />
        </div>
        <h1 style={s.title}>Join Care Moments</h1>
        <p style={s.subtitle}>Create your account — a manager will approve it before you can sign in.</p>

        {error && <div style={s.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={s.label}>Your Full Name</label>
          <input style={s.input} type="text" placeholder="e.g. Sarah Johnson" value={name} onChange={e => setName(e.target.value)} />

          <label style={s.label}>Username</label>
          <input style={s.input} type="text" placeholder="e.g. sarahj" value={username} onChange={e => setUsername(e.target.value)} autoCapitalize="none" autoCorrect="off" />

          <label style={s.label}>Password</label>
          <input style={s.input} type="password" placeholder="Choose a password" value={password} onChange={e => setPassword(e.target.value)} />

          <label style={s.label}>Your Shift</label>
          <div style={s.shiftRow}>
            {['Day', 'Night'].map(sh => (
              <button key={sh} type="button"
                style={{ ...s.shiftBtn, ...(shift === sh ? s.shiftBtnActive : {}) }}
                onClick={() => setShift(sh)}
              >
                {sh === 'Day' ? '☀️' : '🌙'} {sh}
              </button>
            ))}
          </div>

          <button
            style={{ ...s.btn, ...(!canSubmit || submitting ? s.btnDisabled : {}) }}
            type="submit"
            disabled={!canSubmit || submitting}
          >
            {submitting ? 'Sending...' : 'Request Access'}
          </button>
        </form>
      </div>
    </div>
  );
}
